import { Suspense } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import { Button, SubTitle } from "../../Components/CustomComponents/index.js";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
import Table from "../../Components/Table/Table.js";
import { useMentalHealthManagement } from "./hooks/useMentalHealthManagement.js";
import styles from "./styles/user_management.module.scss";
import EditMentalHealthModal from "../../Components/Modals/EditMentalHealthModal.js";

const MentalHealthManagementScreen = () => {
  const {
    searchQuery,
    handleSearchChange,
    rowData,
    columns,
    indication,
    totalRecords,
    totalPages,
    pageSize,
    currentPage,
    setCurrentPage,
    setPageSize,
    refetch,
    dataFetched,
    isFetching,
    isLoading,
    Modals,
    handleAddCategory,
    filterData,
    control,

    deleteModal,
    editedData,
    handleDeleteModalClose,
    deleteData,
    isDeleting,
    editModal,
    handleEditModalClose,
  } = useMentalHealthManagement();

  return (
    <div className={styles.MainContainer}>
      <Modals />
      {editModal && (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditMentalHealthModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
          />
        </Suspense>
      )}
      {deleteModal && (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            onDelete={deleteData}
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col md={6}>
            <div>
              <SubTitle text={"Mental Health Management"} classes="" />
            </div>
          </Col>

          <Col md={6}>
            <div className="d-flex justify-content-end align-items-center gap-2">
              {/* <Input
                classes="w-50"
                type="search"
                placeholder="Search by name"
                value={searchQuery}
                onChange={handleSearchChange}
              />
              <Controller
                control={control}
                name="type"
                render={({ field: { onChange, value } }) => (
                  <span className="w-50">
                    <SelectFieldComponent
                      firstOption={_.isEmpty(value) ? "all" : value}
                      optionsList={filterData}
                      onSelectChange={onChange}
                    />
                  </span>
                )}
              /> */}
              <Button
                classes="w-50"
                text="Add "
                onClick={handleAddCategory}
              ></Button>
            </div>
          </Col>
        </Row>
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords}
                totalPages={totalPages}
                pageSize={pageSize}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setPageSize={setPageSize}
                refetch={refetch}
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default MentalHealthManagementScreen;
